import axios from "axios";

class SlackAPI {
    private static _instance?: SlackAPI;
    private readonly webHookUrl : string

    private constructor() {
        this.webHookUrl = process.env.REACT_APP_SLACK_WEBHOOK ?? "";
    }

    public static instance = this._instance ?? (this._instance = new this());
    public postQnAMessage : ({
name, phone, content,
}: {
        name?: any;
        phone?: any;
        content?: any;
    }) => Promise<boolean> = async ({
name="", phone="", content="",
}) => {
        const result = await axios({
            method: "post",
            url: this.webHookUrl,
            headers: {
                'Content-type': "application/x-www-form-urlencoded",
                accept: "*"
            },
            data: JSON.stringify({
                attachments: [
                    {
                        mrkdwn_in: ["text",'fields'],
                        color: "#36a64f",
                        title: "새로운 상담신청이 도착하였습니다",
                        fields: [
                            {
                                title: "이름",
                                value: name,
                                short: true
                            },
                            {
                                title: "전화번호",
                                value: phone,
                                short: true
                            },
                            {
                                title: "문의 내용",
                                value: content,
                                short: false
                            },
                        ]
                    }
                ]
            })
        });
        return result.status === 200
    }
    public postMessage = async (text:string) => {
        await axios({
            method: "post",
            url: this.webHookUrl,
            headers: {
                'Content-type': "application/x-www-form-urlencoded",
                accept: "*"
            },
            data: JSON.stringify({
                blocks: [
                    {
                        type: 'section',
                        text: {
                            type: "mrkdwn",
                            text
                        }
                    }
                ]
            })
        });
    }
}

export default SlackAPI.instance;
